//
// PickResult.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./PickResultEntry";
import "./PickResultDetails";

var PickResult = createModule("commons::PickResult", [], ClosetObject, [
    ,
    ,
    ,
    {
        shouldUseColor: 2,
        entries: [1],
        color: 3,
        displayListNodeBounds: 12,
        details: 1,
        preferredTargetLocation: 11,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default PickResult;
